import React from 'react';

import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__16} from '@homeaway/svg-defs';
import {LocaleSwitcher} from '@homeaway/react-locale-switcher';
import GlobalizationSelectorConnector from '../../../connectors/GlobalizationSelectorConnector';

import travelerSvgMap from '../../../utils/traveler-svgs';
import {Scratchpad} from '../../scratchpad/Scratchpad';
import {clickedOnTravelerLogin} from '../../../utils/login.utils';
import {namedEvents} from '../../../utils/edap';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {SignUp} from '../../signup/SignUp';

export class TrayMenu extends React.PureComponent {
    static contextType = TrackingContext;

    handleClickHeaderFlag = () => {
        this.props.setActiveMenu('flag');
    }

    handleClickHelp = () => {
        this.props.setActiveMenu('help');
    }

    handleClickLocaleSwitcher = () => {
        this.props.setActiveMenu('locale-switcher');
    }

    handelClickMenuItem = (item) => {
        return () => {
            if (item.cssClass === 'se-traveler-trips') {
                this.context.trigger(namedEvents.TRIP_COLLECTION_SELECTED, {
                    action_location: 'header'
                });
            }
        };
    }

    handleClickLogin = (item) => {
        return (event) => {
            if (this.props.login.travelerLoginClickHandler && clickedOnTravelerLogin(item.cssClass)) {
                event.stopPropagation();
                event.preventDefault();
                this.props.handleTravelerLogin();
                this.props.login.travelerLoginClickHandler();
            }
        };
    }

    // eslint-disable-next-line complexity
    render() {
        return (
            <div className="site-header-tray__menu">
                <div className="site-header-tray__menu-items">
                    {this.props.scratchpad && (
                        <a className="site-header-tray__menu-item-link" data-bypass="true" href={this.props.scratchpad.link}>
                            <Scratchpad
                                iconSize="sm"
                                label={this.props.scratchpad.label}
                                link={this.props.scratchpad.link}
                            />
                        </a>
                    )}
                    {this.props.traveler && this.props.traveler.items.map((item, index) => {
                        if (item.cssClass === 'divider') {
                            return (
                                <div className="site-header-divider" key={`divider-${index}`} />
                            );
                        }

                        // FIXME: This is a hack to identify the inbox item
                        // TODO: Sort out a maintainable way to indentify and handle inbox and inbox data
                        if (item.cssClass === 'se-traveler-inbox') {
                            return (
                                <a className="site-header-tray__menu-item-link" data-bypass="true" href={item.link} key={item.link || index}>
                                    <SVGIcon inlineFlex markup={travelerSvgMap[item.icon]}/><span className="site-header-tray__menu-item-text">{item.text}</span>
                                </a>
                            );
                        }

                        return (
                            <a className="site-header-tray__menu-item-link" data-bypass="true" onClick={this.handelClickMenuItem(item)} href={item.link} key={item.link || index}>
                                <SVGIcon inlineFlex markup={travelerSvgMap[item.icon]}/><span className="site-header-tray__menu-item-text">{item.text}</span>
                            </a>
                        );
                    })}
                    {this.props.login && this.props.login.items && this.props.login.items.map((item, index) =>
                        <a className="site-header-tray__menu-item-link" data-bypass="true" href={item.link} key={item.link || index} onClick={this.handleClickLogin(item)}>{item.text}</a>
                    )}
                    {this.props.renderSignUp && this.props.login && (
                        <SignUp {...this.props.login} linkText="Sign up"/>
                    )}
                    {this.props.flags && (
                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                        <a
                            className="site-header-tray__menu-item-link site-header-tray__menu-item-link--flag site-header-tray__menu-item-link--icon-right"
                            data-bypass="true"
                            onClick={this.handleClickHeaderFlag}
                            onKeyPress={this.handleClickHeaderFlag}
                            role="button"
                            tabIndex={0}
                        >
                            <span>
                                {this.props.isOpen && <i aria-label="flags" className={`flag-${this.props.flags.items[0].countryCode}`} />}
                                <span>{this.props.flags.items[0].text}</span>
                            </span>
                            <SVGIcon className="text-muted" inline markup={CHEVRON_RIGHT__16} />
                        </a>
                    )}
                    {this.props.help && (
                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                        <a
                            className="site-header-tray__menu-item-link site-header-tray__menu-item-link--icon-right"
                            data-bypass="true"
                            onClick={this.handleClickHelp}
                            onKeyPress={this.handleClickHelp}
                            role="button"
                            tabIndex={0}
                        >
                            <span>{this.props.help.label}</span>
                            <SVGIcon className="text-muted" inline markup={CHEVRON_RIGHT__16} />
                        </a>
                    )}
                    {this.props.extraNav && this.props.extraNav.items && this.props.extraNav.items.map((item, index) =>
                        <a className="site-header-tray__menu-item-link" data-bypass="true" href={item.link} key={index}>{item.text}</a>
                    )}
                    {this.props.feedbackComponent && (
                        <div className="site-header-tray__menu-item-link--feedback">{this.props.feedbackComponent}</div>
                    )}
                    {this.props.lyp && (
                        <a className="site-header-tray__menu-item-link" data-bypass="true" href={this.props.lyp.link} target="_blank">{this.props.lyp.text}</a>
                    )}
                    {this.props.localeSwitcher && (
                        <div
                            className="site-header-tray__menu-item-link"
                            onClick={this.handleClickLocaleSwitcher}
                            onKeyPress={this.handleClickLocaleSwitcher}
                            role="button"
                            tabIndex={0}
                            id="locale-switcher-menu"
                        >
                            <LocaleSwitcher/>
                        </div>
                    )}
                    {(this.props.renderCountryLanguageSelector || this.props.renderCurrencySelector) && (
                        <div className="site-header-tray__menu-item-globalization-selector">
                            <GlobalizationSelectorConnector
                                {...this.props.globalizationSelector}
                                countryCode={this.props.countryCode}
                                currencyCode={this.props.currencyCode}
                                languageCode={this.props.languageCode}
                                onGlobalSelectorChange={this.props.onGlobalSelectorChange}
                                renderCountryLanguageSelector={this.props.renderCountryLanguageSelector}
                                renderCurrencySelector={this.props.renderCurrencySelector}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
